<div 
  class="flex items-center justify-center transition-colors border rounded-lg px-0.5 py-2 font-title text-theme-xs w-full" 
  [class.bg-blue-light-500]="(hours() > 0 || minutes() > 0) && !disabled && !isEditingInline()"
  [class.bg-white]="disabled || isEditingInline()"

  [class.text-white]="(hours() > 0 || minutes() > 0) && !disabled && !isEditingInline()"
  [class.text-gray-300]="disabled"
  [class.text-gray-400]="(hours() === 0 && minutes() === 0) && !disabled && !isEditingInline()"
  [class.text-blue-light-500]="(hours() > 0 || minutes() > 0) && disabled"
  [class.text-gray-900]="isEditingInline()"

  [class.border-gray-300]="!disabled && !isEditingInline()"
  [class.border-gray-100]="disabled"
  [class.border-blue-500]="isEditingInline()"
  [class.ring-2]="isEditingInline()"
  [class.ring-blue-500]="isEditingInline()"

  (click)="!isEditingInline() && togglePickerModal()"
  >
  <!--! input de text edicio desktop  -->
  @if (isEditingInline()) {
    <input
      #inlineInput
      type="text"
      class="w-full bg-transparent text-center outline-none border-none p-0 focus:ring-0"
      (blur)="onInputBlur()"
      (input)="onInputChange($event)"
      (keydown)="onKeyDown($event)"
      placeholder="00:00"
    />
  } @else {
    <!--! picker mobil -->

    @if(minutesSeconds()){
      <div>
        {{hoursView()}}' {{minutesView()}}"
      </div>
    } @else {
      <div>
        {{hoursView()}}:{{minutesView()}}
      </div>
    }
  }
</div>

<ion-modal [isOpen]="pickerOpen" (willDismiss)="onWillDismiss($event)" mode="ios">
  <ng-template>
    <ion-picker>
      <ion-picker-column [value]="tmpHours()" (ionChange)="onIonPickerHoursColChange($event)">
        @for(val of hoursOptions; track $index){
          <ion-picker-column-option [value]="val">{{val}}</ion-picker-column-option>
        }
      </ion-picker-column>
      <ion-picker-column [value]="tmpMinutes()" (ionChange)="onIonPickerMinutesColChange($event)">
        @for(val of minutesOptions; track $index){
          <ion-picker-column-option [value]="val">{{val}}</ion-picker-column-option>
        }
      </ion-picker-column>
    </ion-picker>
    
    <ion-toolbar class="ion-no-padding">
      <ion-buttons slot="start">
        <lib-button (click)="onReset()" size="sm" class="ml-6.5 mb-3" [className]="'rounded-full!'" variant="outline">Cancelar</lib-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <lib-button (click)="onConfirm()" size="sm" class="mr-6.5 mb-3" [className]="'rounded-full! bg-blue-500! size-11'" >Confirmar</lib-button>
      </ion-buttons>
    </ion-toolbar>

  </ng-template>

</ion-modal>